import axios from 'axios';
import * as api from './constants';

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v2/sessions_controller.rb#L65
 * @param payload
 * @return {IPromise<U>}
 */
export function loginOutlet(payload) {
  return axios
    .patch(api.UPDATE_SELECTED_OUTLET, payload, { withCredentials: true })
    .then(() => true)
    .catch(error => {
      if (error.response && error.response.data.error) {
        return Promise.reject(new Error(error.response.data.error));
      }
      return Promise.reject(error);
    });
}
